{
  "Parametre": "Parameter",
  "parametre": {
    "E-Mail Görünen mail adres": "E-mail (weergave-adres)",
    "Firma Adı": "Bedrijfsnaam",
    "Host": "Host",
    "Mail": "E-mail",
    "Mail Test": "Mailtest",
    "Parametre": "Parameter",
    "Port": "Poort",
    "Varsayılan Şifre": "Standaard Wachtwoord",
    "Yemek Bedeli": "Maaltijd Kosten",
    "Kapalı": "Uitgeschakeld",
    "E-Posta": "E-Mail",
    "SMS": "SMS",
    "Kullanıcı Tercih Edecek": "Gebruikersvoorkeur",
    "Two Factor Type": "Tweestapsverificatie Type",
    "Seçiniz": "Selecteer",
    "Yeni Kullanıcı Kaydı Aktif": "Nieuwe Gebruiker Registratie Actief",
    "Şifremi Unuttum Aktif": "Wachtwoord Vergeten Actief",
    "Gizlilik Sözleşmesi Metni": "Privacybeleid Tekst",
    "Kurumsal Bilgiler": "Bedrijfsinformatie",
    "Firma Kısa Ad": "Bedrijfsnaam Kort",
    "Kuruluş Yılı": "Oprichtingsjaar",
    "Telefon 1": "Telefoon 1",
    "Telefon 2": "Telefoon 2",
    "Telefon 3": "Telefoon 3",
    "E-mail 1": "E-mail 1",
    "E-mail 2": "E-mail 2",
    "E-mail 3": "E-mail 3",
    "Adres": "Adres",
    "Adres Koordinat X": "Adres Coördinaat X",
    "Adres Koordinat Y": "Adres Coördinaat Y",
    "İletişim Form Mail": "Contactformulier E-mail",
    "SEO Bilgileri": "SEO Informatie",
    "Site Açıklaması": "Site Beschrijving",
    "Anahtar Kelimeler": "Trefwoorden",
    "Diğer Ayarlar": "Overige Instellingen",
    "Facebook": "Facebook",
    "Twitter (X)": "Twitter (X)",
    "Instagram": "Instagram",
    "Youtube": "Youtube",
    "Pinterest": "Pinterest",
    "Aktif": "Actief",
    "satis_izin_gun": "Verkoop Toestemming Dagen",
    "komisyon_vergi": "Commissie Belastingtarief",
    "ape_tarih_ay": "APE Datum Maand",
    "ape_taksit": "APE Aantal Termijnen",
    "ape_peryot": "APE Periode Maand Aantal",
    "smape_tip": "SM APE Berekeningstype (0:Verkoop, 1:Commissie)",
    "smape_tarih_ay": "SM APE Datum Maand",
    "smape_taksit": "SM APE Aantal Termijnen",
    "smape_peryot": "SM APE Periode Maand Aantal",
    "mesai_0": "Zondag",
    "mesai_1": "Maandag",
    "mesai_2": "Dinsdag",
    "mesai_3": "Woensdag",
    "mesai_4": "Donderdag",
    "mesai_5": "Vrijdag",
    "mesai_6": "Zaterdag",
    "panel_ayarlari": "Panelinstellingen",
    "mesai_saatleri": "Werktijden",
    "mail_encryption": "Mailversleuteling (TLS/SSL)",
    "SMS Servis Sağlayıcı": "SMS-serviceprovider",
    "SMS Başlığı": "SMS-koptekst",
    "Servis Kullanıcı Adı / API Key": "Servicegebruikersnaam / API-sleutel",
    "Servis Şifresi / API Secret": "Servis Wachtwoord / API-geheim",
    "Parametre Ayarları": "Parameterinstellingen",
    "Genel Bilgi": "Algemene Informatie",
    "Sosyal Medya": "Sociale Media",
    "Mail Ayarları": "E-mailinstellingen",
    "2FA Ayarları": "2FA-instellingen",
    "Panel Ayarları": "Panelinstellingen",
    "SMS Ayarları": "SMS-instellingen",
    "Programcı": "Programmeur",
    "E-posta 1": "E-mail 1",
    "E-posta 2": "E-mail 2",
    "E-posta 3": "E-mail 3",
    "Mesai Saatleri": "Werkuren",
    "OrnFirmaAdi": "bijv. BEDRIJFSNAAM"
  }
}
